<template>
  <div>
    <tabs-horizontal @input="changedTab" classes="">
      <b-tab-item label="Existing Contact" value="0">
        <div class="search_container">
          <form-field-input
            label="Search for Contacts"
            help-text="by Name, Email Address or Phone Number. Searching for phone number requires at least 3 digits."
            v-model="contactSearch"
            :debounce="searchForContact"
          ></form-field-input>

          <h3 class="search_container--heading">Contacts:</h3>

          <form-field-radio
            v-show="contactResults.length"
            v-model="form.contact_id"
            :items="contactResults"
            :option-label="(contact) => contactDetails(contact)"
            :option-value="(contact) => contact.id"
          ></form-field-radio>

          <p v-if="!contactResults.length" class="search_container--empty">No contacts found...</p>
        </div>
      </b-tab-item>

      <b-tab-item label="New Contact" value="1">
        <div class="pt-100">
          <contact-form ref="contactForm"></contact-form>
        </div>
      </b-tab-item>
    </tabs-horizontal>

    <hr>

    <h3 class="mb-50 has-text-weight-semi-bold">Contact Role</h3>

    <div class="flex flex-vertical-end">
      <form-field-select
        class="mb-0 mr-100"
        style="width: 40%"
        v-model="form.role"
        :validation-errors="validationErrors.role"
      >
        <option v-for="option in ENUMS.RecordRoleEnum" :value="option.value">{{ option.label }}</option>
      </form-field-select>

      <form-field-switch
        label="Make this contact the primary contact?"
        v-model="form.is_primary"
        :validation-errors="validationErrors.is_primary"
        style="margin-bottom: 4px"
      ></form-field-switch>
    </div>

    <hr>

    <h3 class="mb-50 has-text-weight-semi-bold">Make Primary Lead?</h3>

    <form-field-switch
      label="Yes, make this the primary lead for this contact?"
      v-model="form.is_primary_record"
      :validation-errors="validationErrors.is_primary_record"
      style="margin-bottom: 5px"
    ></form-field-switch>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import TabItemSection from "../components/tab/TabItemSection";
import TabsTab from "../components/tab/TabsTab";
import ContactForm from "./ContactForm";
import api from "../api";
import FormFieldRadio from "../components/form/FormFieldRadio";
import {appendModal} from "../services/modals";
import DuplicateWarningModal from "../modules/duplicates/DuplicateWarningModal.vue";

export default {
  name: "AddContactToRecordForm",
  components: {FormFieldRadio, ContactForm, TabsTab, TabItemSection},
  props: {
    formData: {},
  },
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      isExistingContact: true,
      contactSearch: "",
      contactResults: [],
      defaultForm: {
        id: this.$store.state.activeRecord.record.id,
        validate_duplicate: true,
        role: 0,
        is_primary: false,
        is_primary_record: false,
        contact_id: null,
      },
    };
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  methods: {
    contactDetails(contact) {
      let emailAddress = contact.email_address ? contact.email_address : null;
      let phone = contact.phone_1 ? this.$utils.formatNumber(contact.phone_1) : null;
      let fullName = contact.full_name + ": ";

      if (emailAddress && phone) {
        return fullName + emailAddress + " | " + phone;
      } else if (emailAddress && !phone) {
        return fullName + emailAddress;
      } else if (!emailAddress && phone) {
        return fullName + phone;
      } else {
        return fullName;
      }
    },
    searchForContact() {
      const filter = `search=${this.contactSearch}&per_page=200`
      return api.contacts.search(filter)
        .then((res) => {
          this.contactResults = res.data.data
        })
    },
    changedTab($event) {
      this.isExistingContact = ($event === "0");
      this.$emit("changeIsExistingContact", this.isExistingContact);
    },
    update() {
      // Since the id is set, it will always resolve to the update method
      if (this.isExistingContact) {
        this.form.contact = null;
      } else {
        this.form.contact = this.$refs.contactForm.form;
        this.form.contact_id = null;
      }

      return this.$api.records.attachContact(this.form)
        .catch((error) => {
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors

            if (!!this.validationErrors.duplicate_contacts) {
              appendModal(
                DuplicateWarningModal,
                this,
                {
                  duplicateContacts: this.validationErrors.duplicate_contacts,
                  canAttachReplacementInstead: false,
                }
              )
            }
          }

          throw error;
        })
        .then(res => {
          this.$buefy.toast.open({
            message: "Contact was attached to Lead",
            type: "is-success"
          });

          return res;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.search_container {
  padding-top: 1rem;
  min-height: 240px;

  &--heading {
    margin-top: 20px;
    margin-bottom: 12px;
    font-size: 0.9rem;
    color: $text-muted;
  }

  &--empty {
    margin-top: 8px;
    font-style: italic;
    color: $text-muted;
  }
}
</style>
